  <template>
    <div id="ltdunitprofitloss">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> LTD Unit Profit And Loss Summary</div>
                    <div class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'ltdUnitProfitLossSummary'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                            <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'ltdUnitProfitLossSummary'" :position="'top'">
                                </custom-pagination>
                                  <!-- <vue-good-table
                                      ref="LTDUnitProfitLossSummary"
                                      mode="remote"
                                      title="LTD Unit Profit And Loss Summary"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: false,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">
                                  </vue-good-table> -->
                                <div class="vgt-responsive">
                                    <v-table :data="rows" :class="'vgt-table bordered'" :hideSortIcons="true">
                                        <thead slot="head">
                                            <template v-for="(col,ind) in userColumns">
                                                <template v-if="col.sortable == false">
                                                    <th :key="'col_'+ind" :id="col.field" v-show="!col.hidden">{{ col.label }}</th>
                                                </template>
                                                <template v-else>
                                                    <th :key="'col_'+ind" :id="col.field" class="sorting" @click="onSortChangeReports($event)" v-show="!col.hidden">{{ col.label }}</th>
                                                </template>
                                            </template>
                                        </thead>
                                        <tbody slot="body" slot-scope="{displayData}">
                                            <tr v-for="row in displayData">
                                                <template v-for="(col,ind1) in userColumns">
                                                    <td :key="ind1" v-show="!col.hidden">{{ row[col.field] }}</td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </div>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                          </section>
                      </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
// 
// 
// 
import SmartTable from 'vuejs-smart-table'
Vue.use(SmartTable)

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "LTDUnitProfitAndLossSummary",
    metaInfo() {
        return {
            title: "LTD Unit Profit And Loss Summary | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: "Accounting Period End Date",
                field: "period_date",
                hidden:true,
                fpFieldType:"custom_date",
                filterable: true,
                sortable:false
            },
            {
                label:'Unit',
                field:'unit_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Unit Description',
                field:'name',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Unit Year',
                field:'year',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Type',
                field: 'asset_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Equipment Type Description',
                field: 'asset_type_desc',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Current Fac',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
            },
            {
                label: 'Group',
                field: 'group',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Manufacturer Code',
                field: 'manufacturer_code',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Model Code',
                field: 'model_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Equip Pool',
                field: 'asset_pool',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Contract Type',
                field: 'conType',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                sortable:false
            },
            {
                label: 'Agreement Number',
                field: 'agreement_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                sortable:false
            },
            {
                label: 'Schd',
                field: 'schd',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label: 'Customer Name',
                field: 'cust_name',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                sortable:false
            },
            {
                label: 'Customer Number',
                field: 'cust_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                sortable:false
            },
            {
                label: "Unit Assign Date",
                field: "unit_assign_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
                sortable:false
            },
            {
                label: "Contract Terms",
                field: "contract_terms",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                // type: 'number',
                sortable:false
            },
            {
                label: "Termination Date",
                field: "termination_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
                sortable:false
            },
            {
                label: "Fixed Revenue",
                field: "fixed_revenue",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Variable Distance Revenue",
                field: "variable_distance_revenue",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Variable Reefer Revenue",
                field: "variable_reefer_revenue",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Miscellaneous Revenue",
                field: "miscellaneous_revenue",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Substitute Revenue",
                field: "substitute_revenue",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Total Revenue",
                field: "total_revenue",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Labor Expense",
                field: "labor_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Material Expense",
                field: "material_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Total Maintenance Expense",
                field: "total_maintenance_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Lease Margin",
                field: "lease_margin",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Depreciation Expense",
                field: "depreciation_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Interest Expense",
                field: "interest_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Lease Payments",
                field: "lease_payments",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Overhead Expense",
                field: "overhead_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Sub Lease Expense",
                field: "sub_lease_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "HVUT Expense",
                field: "hvut_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Permit Expense",
                field: "permit_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "OS Rental Expense",
                field: "os_rental_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Fuel Expense",
                field: "fuel_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Misc Expense",
                field: "miscellaneous_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Total Overhead Expense",
                field: "total_overhead_expense",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Total Expenses",
                field: "total_expenses",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: "Net Margin",
                field: "net_margin",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
            {
                label: 'VIN#',
                field: 'vin',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Equip Sts Current',
                field: 'status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label: "Billed Metrics",
                field: "billed_metrics",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
             {
                label: "Net Margin Percent",
                field: "net_margin_percent",
                fpFieldType:"integer",
                hidden:false,
                filterable: false,
                type: 'number',
                sortable:false,
            },
            {
                label: "Var Revenue Per Metric",
                field: "var_revenue_per_metric",
                fpFieldType:"integer",
                hidden:false,
                filterable: false,
                type: 'number',
                sortable:false
            },
            {
                label: "Maint Exp Per Metric",
                field: "maint_exp_per_metric",
                fpFieldType:"integer",
                hidden:false,
                filterable: false,
                type: 'number',
                sortable:false
            },
            {
                label: "Months In Service",
                field: "months_in_service",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                // type: 'number',
            },
            {
                label: "Contract Months In Service",
                field: "contract_months_in_service",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                // type: 'number',
            },
            {
                label: "Current NBV",
                field: "net_book_value",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list',
        batchProcess:0,
        batchNum:"",
        filterAll:[],
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ltd_unit_profit_and_loss_summary') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.LTDUnitProfitLossSummary.unselectAllInternal();
        },
        loadList() {
            var self = this;
            var selectedRows = [];
            // var data = this.$refs['LTDUnitProfitLossSummary'].selectedRows;
            // for ( var i = 0; i < data.length; i++ ) {
            //     selectedRows.push(data[i].id)
            // }
            self.filterAll = self.serverParams.columnFilters;
            // if ( self.action == "export" ) {
            //     self.filterAll = self.removeOptionArr(self.serverParams.columnFilters);
            // }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters:self.filterAll,
                sort: self.serverParams.sort,
                action:self.action,
                selectedAll:self.serverParams.selectedAll,
                selectedRows:selectedRows,
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/ltd-unit-profit-loss",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if ( self.action == "export" ||  self.action == "export_queue") {

                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                if ( self.action == "export" ) {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }

                            }

                            self.action = "list";
                            // self.loadList();
                            return;

                        } else {
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'ltd-unit-profit-loss')
                }
            });
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/LTDUnitProfitAndLossSummary.vue